import { fetchWithTokenRefresh } from "./withTokenRefresh";

const updateTimezone = async (userId, timeZone) => {
  const url = `/account/api/users/${userId}`;
  const response = await fetchWithTokenRefresh(url, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      data: {
        attributes: { time_zone: timeZone },
      },
    }),
  });

  let body;
  try {
    body = await response.json();
  } catch {
    body = { message: response.statusText };
  }

  if (response.ok) {
    return { data: body };
  }

  return {
    error: {
      status: response.status,
      statusText: response.statusText,
      body,
    },
  };
};

export default { updateTimezone };
